// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FavoriteTerritoryCell.isActive,
.FavoriteTerritoryCell:has(.FavoriteButton--isSaved) {
  display: inherit;
}`, "",{"version":3,"sources":["webpack://./src/modules/territory/favorite-territory-cell/favorite-territory-cell.styles.scss"],"names":[],"mappings":"AAAA;;EAEE,gBAAA;AACF","sourcesContent":[".FavoriteTerritoryCell.isActive,\n.FavoriteTerritoryCell:has(.FavoriteButton--isSaved) {\n  display: inherit;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
